/* Great Lakes Lavender Farm — Lavender Grower Academy. Read-only: progress lives in this browser only. */
(function () {
  "use strict";
  var root = document.getElementById("gga");
  if (!root || root.__gga) return;
  root.__gga = true;
  root.classList.remove("gga-nojs");
  var KEY = "gllfGrowerAcademyV1";
  var RM = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  var st = load(); st.l = st.l || {}; st.q = st.q || {};
  function save() { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function jsonOf(sel) { var n = $(sel); try { return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; } }

  /* ---------- library ---------- */
  var MODS = {};
  $$("[data-lib]").forEach(function (d) {
    var m = +d.getAttribute("data-lib");
    var tools = []; try { tools = JSON.parse(d.getAttribute("data-tools")); } catch (e) {}
    MODS[m] = { title: d.getAttribute("data-title"), track: d.getAttribute("data-track"), art: d.getAttribute("data-art"), tools: tools,
      lessons: $$("article[data-l]", d), quiz: $("form[data-quiz]", d) };
  });
  var MIDS = Object.keys(MODS).map(Number).sort(function (a, b) { return a - b; });
  function nL(m) { return MODS[m].lessons.length; }
  function lessonDone(m, l) { return !!st.l[m + "-" + l]; }
  function modDone(m) { for (var i = 1; i <= nL(m); i++) if (!lessonDone(m, i)) return false; return !!st.q[m]; }
  function modSteps(m) { var c = 0; for (var i = 1; i <= nL(m); i++) if (lessonDone(m, i)) c++; return c + (st.q[m] ? 1 : 0); }
  function totals() { var d = 0, t = 0; MIDS.forEach(function (m) { d += modSteps(m); t += nL(m) + 1; }); return { d: d, t: t, pct: Math.round(d / t * 100), mods: MIDS.filter(modDone).length }; }
  function nextStop() {
    for (var i = 0; i < MIDS.length; i++) { var m = MIDS[i];
      for (var l = 1; l <= nL(m); l++) if (!lessonDone(m, l)) return { m: m, s: l - 1 };
      if (!st.q[m]) return { m: m, s: nL(m) }; }
    return null;
  }

  /* ---------- progress UI ---------- */
  function paint() {
    var T = totals();
    var bar = $("[data-gga-bar]"); if (bar) bar.style.width = T.pct + "%";
    var pc = $("[data-gga-pct]"); if (pc) pc.textContent = T.pct + "%";
    $$(".gga-mod[data-mod]").forEach(function (card) {
      var m = +card.getAttribute("data-mod"), n = nL(m), s = modSteps(m), done = modDone(m);
      card.classList.toggle("is-done", done);
      $$(".gga-mod__ls li", card).forEach(function (li) {
        var l = li.getAttribute("data-l");
        li.classList.toggle("is-done", l === "q" ? !!st.q[m] : lessonDone(m, +l));
      });
      $(".gga-mod__bar i", card).style.width = Math.round(s / (n + 1) * 100) + "%";
      var btn = $("button[data-open]", card), status = $("[data-gga-status]", card);
      var mins = status.getAttribute("data-min") || status.textContent.split(" ")[0];
      status.setAttribute("data-min", mins);
      status.textContent = done ? "Complete ✓" : s ? (s + " of " + (n + 1) + " done") : (mins + " min · Not started");
      btn.textContent = done ? "Review" : s ? "Continue" : "Start";
    });
    var cs = $("[data-gga-certstatus]"); if (cs) cs.textContent = T.mods === MIDS.length ? "Unlocked ✓" : T.mods + " of " + MIDS.length + " modules";
    $$("[data-dot]").forEach(function (d) { d.classList.toggle("is-done", modDone(+d.getAttribute("data-dot"))); });
    // resume
    var res = $("[data-gga-resume]"), nx = nextStop();
    if (res) {
      if (T.d > 0) {
        res.hidden = false;
        var ring = $(".gga-ring", res); ring.style.setProperty("--p", T.pct); $("span", ring).textContent = T.pct + "%";
        var first = root.getAttribute("data-first") || st.first || "";
        $("[data-gga-hello]", res).textContent = first ? "Welcome back, " + first + "." : "Welcome back.";
        $("[data-gga-resume-t]", res).textContent = T.mods + " of " + MIDS.length + " modules complete.";
        var ra = $("[data-gga-resume-a]", res);
        if (nx) { ra.textContent = "Resume Module " + nx.m + " →"; ra.onclick = function (e) { e.preventDefault(); openReader(nx.m, nx.s); }; }
        else { ra.textContent = "See your certificate →"; ra.onclick = function (e) { e.preventDefault(); go("#gga-cert"); }; }
      } else res.hidden = true;
    }
    $$("[data-gga-startbtn]").forEach(function (b) {
      if (T.d === 0) return;
      if (nx) { b.setAttribute("data-open", nx.m); b.innerHTML = "Continue Module " + nx.m + ' <span aria-hidden="true">→</span>'; }
      else { b.removeAttribute("data-open"); b.setAttribute("data-go", "#gga-cert"); b.textContent = "View my certificate"; }
    });
    paintCert(T);
  }

  /* ---------- certificate ---------- */
  function paintCert(T) {
    var all = T.mods === MIDS.length, card = $("[data-gga-certcard]");
    if (!card) return;
    card.classList.toggle("is-locked", !all);
    $("[data-gga-namefield]").hidden = !all;
    $("[data-gga-print]").hidden = !all;
    var nx = $("[data-gga-next]"); nx.hidden = all;
    $("[data-gga-certmsg]").textContent = all ? "You did it. Add your name, then print or save your certificate as a PDF."
      : T.mods + " of " + MIDS.length + " modules complete. Finish every lesson and knowledge check to unlock your printable certificate.";
    if (all && !st.date) { st.date = new Date().toISOString().slice(0, 10); save(); }
    var nm = st.name || root.getAttribute("data-full") || "";
    var inp = $("#gga-name"); if (inp && !inp.value) inp.value = nm;
    $("[data-gga-certname]").textContent = nm || "Your Name";
    $("[data-gga-certdate]").textContent = st.date ? new Date(st.date + "T12:00:00").toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }) : "—";
  }
  var nameIn = $("#gga-name");
  if (nameIn) nameIn.addEventListener("input", function () { st.name = nameIn.value.trim(); save(); $("[data-gga-certname]").textContent = st.name || "Your Name"; });
  var pr = $("[data-gga-print]"); if (pr) pr.addEventListener("click", function () { window.print(); });
  var nb = $("[data-gga-next]"); if (nb) nb.addEventListener("click", function () { var n = nextStop(); if (n) openReader(n.m, n.s); });

  /* ---------- reader ---------- */
  var dlg = $(".gga-reader"), R = {};
  $$("[data-r]", dlg).forEach(function (n) { R[n.getAttribute("data-r")] = n; });
  var cur = { m: 1, s: 0 }, lastFocus = null;
  function openReader(m, s) {
    if (!MODS[m]) return;
    lastFocus = document.activeElement;
    cur.m = m; cur.s = s == null ? (function () { for (var l = 1; l <= nL(m); l++) if (!lessonDone(m, l)) return l - 1; return st.q[m] ? 0 : nL(m); })() : s;
    var M = MODS[m];
    R.art.src = M.art; R.kick.textContent = "Module " + (m < 10 ? "0" + m : m) + " · " + M.track; R.title.textContent = M.title;
    if (dlg.showModal && !dlg.open) { dlg.showModal(); } else if (!dlg.open) dlg.setAttribute("open", "");
    document.documentElement.style.overflow = "hidden";
    renderStep();
    try { history.replaceState(null, "", "#gga-m" + m); } catch (e) {}
  }
  function closeReader() {
    if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute("open"); }
  }
  dlg.addEventListener("close", function () {
    document.documentElement.style.overflow = "";
    try { history.replaceState(null, "", location.pathname + location.search); } catch (e) {}
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    paint();
  });
  dlg.addEventListener("click", function (e) { if (e.target === dlg) closeReader(); });
  R.close.addEventListener("click", closeReader);

  function renderStep() {
    var m = cur.m, M = MODS[m], n = nL(m), isQ = cur.s === n;
    // steps
    R.steps.innerHTML = "";
    for (var i = 0; i <= n; i++) {
      var b = document.createElement("button"); b.type = "button"; b.setAttribute("role", "tab");
      b.setAttribute("aria-selected", i === cur.s ? "true" : "false");
      var done = i < n ? lessonDone(m, i + 1) : !!st.q[m];
      if (done) b.classList.add("is-done");
      b.innerHTML = "<i>" + (done ? "✓" : i < n ? i + 1 : "?") + "</i>" + (i < n ? M.lessons[i].getAttribute("data-t") : "Knowledge check");
      (function (k) { b.addEventListener("click", function () { cur.s = k; renderStep(); }); })(i);
      R.steps.appendChild(b);
    }
    var sel = R.steps.children[cur.s]; if (sel) R.steps.scrollLeft = Math.max(0, sel.offsetLeft - 40);
    // body
    R.body.innerHTML = "";
    var node = (isQ ? M.quiz : M.lessons[cur.s]).cloneNode(true);
    R.body.appendChild(node);
    if (!isQ && cur.s === n - 1 && M.tools.length) {
      var ch = document.createElement("div"); ch.className = "gga-chips";
      ch.innerHTML = "<span>Tools for this module</span>" + M.tools.map(function (t) { return '<a href="/pages/' + t[0] + '">' + esc(t[1]) + " ↗</a>"; }).join("");
      R.body.appendChild(ch);
    }
    if (isQ) wireQuiz(node, m);
    R.body.scrollTop = 0; R.body.focus({ preventScroll: true });
    // foot
    R.prev.disabled = cur.s === 0 && m === MIDS[0];
    R.count.textContent = isQ ? "Knowledge check" : "Lesson " + (cur.s + 1) + " of " + n;
    if (isQ) {
      R.next.textContent = st.q[m] ? (m === MIDS[MIDS.length - 1] ? "Finish ✓" : "Next module →") : "Check answers";
    } else {
      R.next.textContent = cur.s === n - 1 ? "Complete & take the check →" : "Complete & continue →";
    }
  }
  function esc(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }
  R.prev.addEventListener("click", function () {
    if (cur.s > 0) { cur.s--; renderStep(); }
    else { var i = MIDS.indexOf(cur.m); if (i > 0) openReader(MIDS[i - 1], nL(MIDS[i - 1])); }
  });
  R.next.addEventListener("click", function () {
    var m = cur.m, n = nL(m);
    if (cur.s < n) {
      if (!lessonDone(m, cur.s + 1)) { st.l[m + "-" + (cur.s + 1)] = 1; save(); }
      cur.s++; renderStep(); paint(); return;
    }
    if (!st.q[m]) { var f = $("form[data-quiz]", R.body); if (f) grade(f, m); return; }
    var i = MIDS.indexOf(m);
    if (i < MIDS.length - 1) openReader(MIDS[i + 1], null);
    else { closeReader(); go("#gga-cert"); }
  });
  R.body.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a[data-gga-close]");
    if (a) { e.preventDefault(); closeReader(); go(a.getAttribute("href")); }
  });

  function wireQuiz(f, m) {
    f.addEventListener("submit", function (e) { e.preventDefault(); grade(f, m); });
    if (st.q[m]) {
      $$(".gga-q", f).forEach(function (q) { var r = $$("input", q)[+q.getAttribute("data-answer")]; if (r) r.checked = true; q.classList.add("is-right"); });
      var msg = $(".gga-quizmsg", f); msg.hidden = false; msg.className = "gga-quizmsg ok"; msg.textContent = "Module complete. Nice work!";
    }
    f.addEventListener("change", function (e) { var q = e.target.closest(".gga-q"); if (q) q.classList.remove("is-right", "is-wrong"); });
  }
  function grade(f, m) {
    var qs = $$(".gga-q", f), right = 0, blank = 0;
    qs.forEach(function (q) {
      var c = $("input:checked", q); q.classList.remove("is-right", "is-wrong");
      if (!c) { blank++; return; }
      var ok = +c.value === +q.getAttribute("data-answer"); if (ok) right++;
      q.classList.add(ok ? "is-right" : "is-wrong");
    });
    var msg = $(".gga-quizmsg", f); msg.hidden = false;
    if (blank) { msg.className = "gga-quizmsg no"; msg.textContent = "Answer all " + qs.length + " questions, then check again."; return; }
    if (right === qs.length) {
      st.q[m] = 1; for (var l = 1; l <= nL(m); l++) st.l[m + "-" + l] = 1; save();
      msg.className = "gga-quizmsg ok"; msg.textContent = "All " + qs.length + " right — Module " + m + " complete!";
      burst(); toast(totals().mods === MIDS.length ? "Course complete — your certificate is unlocked!" : "Module " + m + " complete ✓");
      renderStep(); paint();
      var nm = $(".gga-quizmsg", R.body); if (nm) { nm.hidden = false; nm.className = "gga-quizmsg ok"; nm.textContent = msg.textContent; }
    } else {
      msg.className = "gga-quizmsg no"; msg.textContent = right + " of " + qs.length + " right. Read the notes, change your answers and check again.";
    }
  }

  /* ---------- open triggers ---------- */
  root.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-open],[data-go]");
    if (!b) return;
    e.preventDefault();
    if (b.hasAttribute("data-open")) openReader(+b.getAttribute("data-open"), null); else go(b.getAttribute("data-go"));
  });
  $$(".gga-mod[data-mod] .gga-mod__art, .gga-mod[data-mod] h3").forEach(function (n) {
    n.style.cursor = "pointer";
    n.addEventListener("click", function () { openReader(+n.closest(".gga-mod").getAttribute("data-mod"), null); });
  });

  /* ---------- smooth nav + sticky offset ---------- */
  function headerBottom() {
    var b = 0;
    document.querySelectorAll(".shopify-section-group-header-group, #shopify-section-header, sticky-header, body > header").forEach(function (h) {
      if (root.contains(h)) return;
      var p = getComputedStyle(h).position;
      if (p !== "sticky" && p !== "fixed") return;
      var r = h.getBoundingClientRect();
      if (r.top <= 2 && r.bottom > b && r.height < innerHeight / 2) b = r.bottom;
    });
    return Math.round(b);
  }
  var topPx = 0;
  function syncTop() {
    var t = headerBottom();
    if (t !== topPx) { topPx = t; root.style.setProperty("--top", t + "px"); }
    root.classList.toggle("is-stick", innerHeight - t >= 600);
  }
  window.addEventListener("resize", syncTop);
  setInterval(function () { if (!document.hidden) syncTop(); }, 200);
  function go(hash) {
    var t = document.querySelector(hash); if (!t) return;
    var nav = $(".gga-nav"), off = topPx + (nav && root.classList.contains("is-stick") ? nav.offsetHeight : 0) + 12;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off, behavior: RM ? "auto" : "smooth" });
  }
  $$(".gga-nav a, .gga-hero a[href^='#'], .gga-hero__scroll").forEach(function (a) {
    a.addEventListener("click", function (e) { var h = a.getAttribute("href"); if (h && h[0] === "#") { e.preventDefault(); go(h); } });
  });
  var ticking = false;
  window.addEventListener("scroll", function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; syncTop(); spy(); }); }, { passive: true });
  var navLinks = $$(".gga-nav__links a");
  function spy() {
    var y = topPx + 220, on = null;
    navLinks.forEach(function (a) { var s = document.querySelector(a.getAttribute("href")); if (s && s.getBoundingClientRect().top <= y) on = a; });
    navLinks.forEach(function (a) { a.classList.toggle("is-on", a === on); });
    if (on && on.__last !== true) { navLinks.forEach(function (a) { a.__last = false; }); on.__last = true; var ul = on.parentNode.parentNode; if (ul.scrollTo) ul.scrollTo({ left: on.offsetLeft - 20, behavior: "smooth" }); }
  }
  syncTop();

  /* ---------- reveal ---------- */
  if ("IntersectionObserver" in window && !RM) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } }); }, { rootMargin: "0px 0px -8% 0px", threshold: .08 });
    $$(".gga-rv").forEach(function (n) { io.observe(n); });
  } else $$(".gga-rv").forEach(function (n) { n.classList.add("is-in"); });

  /* ---------- hero parallax ---------- */
  var par = $("[data-gga-parallax]");
  if (par && !RM && matchMedia("(pointer:fine)").matches) {
    var layers = $$("img[data-depth]", par), raf = 0, mx = 0, my = 0;
    $(".gga-hero").addEventListener("pointermove", function (e) {
      var r = par.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; layers.forEach(function (l) { var d = +l.getAttribute("data-depth"); l.style.transform = "translate3d(" + (-mx * d).toFixed(1) + "px," + (-my * d).toFixed(1) + "px,0)"; }); });
    });
  }

  /* ---------- regions ---------- */
  var REG = jsonOf("[data-gga-regions]") || [], rp = $("[data-gga-rpanel]");
  function showRegion(i) {
    var r = REG[i]; if (!r || !rp) return;
    $$(".gga-rtile").forEach(function (b) { b.setAttribute("aria-pressed", +b.getAttribute("data-region") === i ? "true" : "false"); });
    rp.innerHTML = '<div class="gga-rpanel__art">' + (r.h ? '<span class="gga-rpanel__home">Our home ground</span>' : "") + '<img src="' + r.a + '" alt="" width="384" height="384"></div><div class="gga-rpanel__body"><h3>' + esc(r.n) + '</h3><p class="gga-rpanel__ch">' + esc(r.c) + "</p><ul>" +
      r.t.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("") + "</ul>" +
      (r.s ? '<div class="gga-ship"><span aria-hidden="true">📦</span><div><b>Shipping to ' + esc(r.s) + ":</b> plants in soil can&rsquo;t ship there because of state plant rules — bare root plants can.</div></div>" : "") +
      '<a class="gga-btn gga-btn--sm" href="/pages/growing-zone">Find my exact zone →</a></div>';
    try { localStorage.setItem(KEY + ":region", i); } catch (e) {}
  }
  $$(".gga-rtile").forEach(function (b) { b.addEventListener("click", function () { showRegion(+b.getAttribute("data-region")); }); });
  var ri = 0; try { ri = +(localStorage.getItem(KEY + ":region") || 0); } catch (e) {}
  showRegion(REG[ri] ? ri : 0);

  /* ---------- calculator ---------- */
  var unit = "ft";
  function num(id) { var v = parseFloat(($("#" + id) || {}).value); return isFinite(v) && v > 0 ? v : 0; }
  var MN = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  function fmt(n) { return Math.round(n).toLocaleString(); }
  function calc() {
    var L, W;
    if (unit === "ac") { var side = Math.sqrt(num("gga-ac") * 43560); L = side; W = side; } else { L = num("gga-len"); W = num("gga-wid"); }
    var inrow = num("gga-inrow") / 12, rowSp = num("gga-row"), extra = num("gga-extra") / 100;
    var rows = W && rowSp ? Math.max(1, Math.floor(W / rowSp)) : 0;
    var per = L && inrow ? Math.max(1, Math.floor(L / inrow)) : 0;
    var base = rows * per, plants = Math.ceil(base * (1 + extra));
    var trays = Math.ceil(plants / 72), bare = plants ? Math.max(25, Math.ceil(plants / 25) * 25) : 0;
    var set = function (k, v) { var n = $('[data-o="' + k + '"]'); if (n) n.textContent = v; };
    animateNum($('[data-o="plants"]'), plants);
    set("rows", fmt(rows)); set("rowsl", "rows × " + fmt(per) + " plants"); set("trays", fmt(trays)); set("bare", fmt(bare)); set("drip", fmt(rows * L));
    var pm = +$("#gga-month").value, rb = MN[(pm + 12 - 6) % 12];
    var note = "Reserve by <b>" + rb + "</b> for " + MN[pm] + " planting — about six months ahead.";
    if (trays >= 2) note += " Two or more 72-cell trays meets the wholesale tray minimum, and varieties can be mixed.";
    else note += " Planting more than 72? Two trays unlock wholesale tray pricing.";
    $('[data-o="note"]').innerHTML = note;
    try { localStorage.setItem(KEY + ":calc", JSON.stringify({ u: unit, len: $("#gga-len").value, wid: $("#gga-wid").value, ac: $("#gga-ac").value, inrow: $("#gga-inrow").value, row: $("#gga-row").value, extra: $("#gga-extra").value, mo: $("#gga-month").value })); } catch (e) {}
  }
  function animateNum(n, to) {
    if (!n) return; var from = +(n.getAttribute("data-v") || 0); n.setAttribute("data-v", to);
    if (RM || from === to) { n.textContent = fmt(to); return; }
    var t0 = performance.now(), dur = 600;
    (function step(t) { var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); n.textContent = fmt(from + (to - from) * e); if (p < 1) requestAnimationFrame(step); })(t0);
  }
  function setUnit(u) {
    unit = u;
    $$(".gga-seg button").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-unit") === u ? "true" : "false"); });
    $$("[data-f]").forEach(function (f) { f.hidden = f.getAttribute("data-f") !== u; });
    calc();
  }
  try { var sv = JSON.parse(localStorage.getItem(KEY + ":calc")); if (sv) { ["len", "wid", "ac", "inrow", "row", "extra"].forEach(function (k) { if (sv[k]) $("#gga-" + k).value = sv[k]; }); if (sv.mo) $("#gga-month").value = sv.mo; if (sv.u) unit = sv.u; } } catch (e) {}
  $$(".gga-seg button").forEach(function (b) { b.addEventListener("click", function () { setUnit(b.getAttribute("data-unit")); }); });
  $$(".gga-calc input, .gga-calc select").forEach(function (i) { i.addEventListener("input", calc); i.addEventListener("change", calc); });
  setUnit(unit);

  /* ---------- year ---------- */
  var MON = jsonOf("[data-gga-months]") || [], mp = $("[data-gga-month]"), now = new Date().getMonth();
  function showMonth(i) {
    var m = MON[i]; if (!m || !mp) return;
    $$(".gga-gantt__m").forEach(function (b) { b.setAttribute("aria-pressed", +b.getAttribute("data-month") === i ? "true" : "false"); });
    mp.innerHTML = '<img src="' + m.a + '" alt="" width="384" height="384"><div><p class="k">' + (i === now ? "This month · " : "") + esc(m.k) + "</p><h3>" + esc(m.n) + "</h3><ul>" + m.t.map(function (t) { return "<li>" + esc(t) + "</li>"; }).join("") + "</ul></div>";
  }
  $$(".gga-gantt__m").forEach(function (b) {
    if (+b.getAttribute("data-month") === now) b.classList.add("is-now");
    b.addEventListener("click", function () { showMonth(+b.getAttribute("data-month")); });
  });
  showMonth(now);

  /* ---------- plants ---------- */
  var rail = $("[data-gga-rail]");
  function card(p) {
    var parts = p.t.split(" - "), name = parts[0].replace(/\s+(Live\s+)?Plants?.*$/i, "").trim() || parts[0], bot = (parts[1] || "").replace(/\s*\(.*$/, "");
    return '<a class="gga-plant" href="' + p.u + '"><div class="gga-plant__img">' + (p.i ? '<img src="' + p.i + '" alt="" loading="lazy" width="520" height="520">' : "") + '</div><div class="gga-plant__b"><h3>' + esc(name) + "</h3><i>" + esc(bot) + "</i><span>" + (p.p ? "From " + esc(p.p) + " · " : "") + "Available now</span></div></a>";
  }
  function fillRail(list) {
    if (!rail) return;
    if (!list || !list.length) { rail.innerHTML = '<div class="gga-rail__empty">New plants are on the way. <a href="/pages/availability-alerts">Get an availability alert</a> and we&rsquo;ll let you know.</div>'; return; }
    rail.innerHTML = list.map(card).join("");
  }
  var island = jsonOf("[data-gga-plants]");
  if (island && island.length) fillRail(island);
  else if (rail) {
    var loaded = false, loadPlants = function () {
      if (loaded) return; loaded = true;
      fetch("/collections/live-plants/products.json?limit=250").then(function (r) { return r.json(); }).then(function (j) {
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
        fillRail((j.products || []).filter(function (p) { return p.variants.some(function (v) { return v.available; }); }).slice(0, 10).map(function (p) {
          var min = Math.min.apply(null, p.variants.map(function (v) { return parseFloat(v.price); }));
          var price = isFinite(min) ? new Intl.NumberFormat(undefined, { style: "currency", currency: cur, minimumFractionDigits: min % 1 ? 2 : 0 }).format(min) : "";
          return { t: p.title, u: "/products/" + p.handle, i: p.images[0] ? p.images[0].src.replace(/(\.\w+)(\?|$)/, "_520x$1$2") : "", p: price };
        }));
      }).catch(function () { fillRail([]); });
    };
    if ("IntersectionObserver" in window) { var pio = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { pio.disconnect(); loadPlants(); } }, { rootMargin: "600px" }); pio.observe(rail); } else loadPlants();
  }

  /* ---------- celebration ---------- */
  function toast(t) {
    var n = document.createElement("div"); n.className = "gga-toast"; n.setAttribute("role", "status"); n.textContent = t;
    (dlg.open ? dlg : root).appendChild(n); requestAnimationFrame(function () { n.classList.add("is-on"); });
    setTimeout(function () { n.classList.remove("is-on"); setTimeout(function () { n.remove(); }, 600); }, 3200);
  }
  function burst() {
    if (RM) return;
    var c = document.createElement("canvas"); c.className = "gga-burst"; (dlg.open ? dlg : root).appendChild(c);
    var dpr = Math.min(2, window.devicePixelRatio || 1), W = c.width = innerWidth * dpr, H = c.height = innerHeight * dpr, x = c.getContext("2d");
    c.style.width = innerWidth + "px"; c.style.height = innerHeight + "px";
    var cols = ["#8a5a92", "#b07ab8", "#d3a64a", "#6b3f71", "#e9c6f0", "#5d7f58"], P = [];
    for (var i = 0; i < 140; i++) P.push({ x: W / 2, y: H * .55, vx: (Math.random() - .5) * 26 * dpr, vy: (-Math.random() * 22 - 8) * dpr, r: (Math.random() * 5 + 3) * dpr, a: Math.random() * 6, va: (Math.random() - .5) * .3, c: cols[i % cols.length] });
    var t0 = performance.now();
    (function f(t) {
      var k = (t - t0) / 1800; x.clearRect(0, 0, W, H);
      P.forEach(function (p) { p.vy += .55 * dpr; p.vx *= .985; p.x += p.vx; p.y += p.vy; p.a += p.va; x.save(); x.globalAlpha = Math.max(0, 1 - k); x.translate(p.x, p.y); x.rotate(p.a); x.fillStyle = p.c; x.beginPath(); x.ellipse(0, 0, p.r, p.r * 2, 0, 0, 7); x.fill(); x.restore(); });
      if (k < 1) requestAnimationFrame(f); else c.remove();
    })(t0);
  }

  /* ---------- boot ---------- */
  paint();
  var h = location.hash.match(/^#gga-m(\d+)$/);
  if (h && MODS[+h[1]]) setTimeout(function () { openReader(+h[1], null); }, 300);
})();
